import React, { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as InstagramIcon } from '../assets/icons/instagram_icon.svg';
import { ReactComponent as TikTokIcon } from '../assets/icons/tiktok_icon.svg';
import { ReactComponent as EmailIcon } from '../assets/icons/email_icon.svg';
import fotoContato from '../assets/img/foto_grupo_3.png';

const ContatoSectionContainer = styled.section`
  display: flex;
  width: 100%;
  min-height: 100vh;

  @media (max-width: 900px) {
    flex-direction: column;
    min-height: unset;
  }
`;

const ContatoLeft = styled.div`
  flex: 1.1;
  background: #ba3b3b;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0eadd;
  padding: 0 4vw;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
    min-height: 50vh;
    order: 1;
  }
`;

const ContatoContent = styled.div`
  max-width: 600px;
  width: 100%;

  @media (max-width: 900px) {
    max-width: 95vw;
    padding: 24px 0;
  }
`;

const ContatoTitle = styled.h2`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 80px;
  font-weight: bold;
  color: #f0eadd;
  line-height: 1;
  margin-bottom: 32px;

  @media (max-width: 1100px) {
    font-size: 48px;
  }
`;

const ContatoDescription = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 23.5px;
  color: #f0eadd;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 40px;

  @media (max-width: 1100px) {
    font-size: 16px;
  }
`;

const ContatoLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ContatoLink = styled.a`
  display: flex;
  align-items: center;
  gap: 15px;
  background: #222;
  color: #f0eadd;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding: 16px 24px;
  border: 2px solid #f0eadd;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: #f0eadd;
    color: #222;
    transform: translateY(-2px);
  }

  @media (max-width: 1100px) {
    font-size: 16px;
    padding: 14px 20px;
  }
`;

const EmailButton = styled.button`
  display: flex;
  align-items: center;
  gap: 15px;
  background: #222;
  color: #f0eadd;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding: 16px 24px;
  border: 2px solid #f0eadd;
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  text-align: left;

  &:hover {
    background: #f0eadd;
    color: #222;
    transform: translateY(-2px);
  }

  @media (max-width: 1100px) {
    font-size: 16px;
    padding: 14px 20px;
  }
`;

const ContatoIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
    stroke: currentColor;
  }
  
  @media (max-width: 1100px) {
    width: 20px;
    height: 20px;
  }
`;

const CopyNotification = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background: #4CAF50;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  z-index: 1000;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @media (max-width: 900px) {
    top: 10px;
    right: 10px;
    left: 10px;
    text-align: center;
  }
`;

const ContatoRight = styled.div`
  flex: 1;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  background: #222;
  overflow: hidden;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
    min-height: 40vh;
    order: 2;
  }
`;

const ContatoImg = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    height: 40vh;
  }
`;

const ContatoSection = () => {
  const [showCopyNotification, setShowCopyNotification] = useState(false);

  const handleEmailCopy = async () => {
    try {
      await navigator.clipboard.writeText('contato@quatrotakes.com');
      setShowCopyNotification(true);
      
      // Esconde a notificação após 3 segundos
      setTimeout(() => {
        setShowCopyNotification(false);
      }, 3000);
    } catch (err) {
      console.error('Erro ao copiar email:', err);
      // Fallback para navegadores mais antigos
      const textArea = document.createElement('textarea');
      textArea.value = 'contato@quatrotakes.com';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      setShowCopyNotification(true);
      setTimeout(() => {
        setShowCopyNotification(false);
      }, 3000);
    }
  };

  return (
    <ContatoSectionContainer id="contato">
      <ContatoRight>
        <ContatoImg src={fotoContato} />
      </ContatoRight>
      <ContatoLeft>
        <ContatoContent>
          <ContatoTitle>Contato</ContatoTitle>
          <ContatoDescription>
            Entre em contato conosco através das nossas redes sociais ou por email. 
            Estamos sempre abertos a parcerias, sugestões e conversas sobre cultura pop!
          </ContatoDescription>
          <ContatoLinks>
            <ContatoLink 
              href="https://www.instagram.com/quatrotakes/" 
              target="_blank"
              rel="noopener noreferrer"
            >
              <ContatoIcon>
                <InstagramIcon />
              </ContatoIcon>
              Instagram @quatrotakes
            </ContatoLink>
            <ContatoLink 
              href="https://www.tiktok.com/@quatrotakes" 
              target="_blank"
              rel="noopener noreferrer"
            >
              <ContatoIcon>
                <TikTokIcon />
              </ContatoIcon>
              TikTok @quatrotakes
            </ContatoLink>
            <EmailButton onClick={handleEmailCopy}>
              <ContatoIcon>
                <EmailIcon />
              </ContatoIcon>
              Email contato@quatrotakes.com
            </EmailButton>
          </ContatoLinks>
        </ContatoContent>
      </ContatoLeft>
      
      {showCopyNotification && (
        <CopyNotification>
          ✉️ Copiado para a área de transferência!
        </CopyNotification>
      )}
    </ContatoSectionContainer>
  );
};

export default ContatoSection;
